import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IBarcodeItem } from "../objects";
import { IBarcodeInformationSpecification } from "../IFormatSpecification";
import { instanceOfINamePropertyEditable } from "./INamePropertyEditable";

export interface IBarcodeItemsPropertyEditable {
  name(): IPropertyEditable<string>;
  barcodeItems(): IPropertyEditable<IBarcodeItem[]>;
  getSelectableBarcodeInformations(): IBarcodeInformationSpecification[];
}

export function instanceOfIBarcodeItemsPropertyEditable(instance: any): instance is IBarcodeItemsPropertyEditable {
  return instance
      && instance.barcodeItems
      && instance.getSelectableBarcodeInformations
      && instanceOfIPropertyEditable<IBarcodeItem[]>(instance.barcodeItems())
      && instanceOfINamePropertyEditable(instance);
}
